import us from './en-us'
import type { CommonLang } from './types'

const lang: CommonLang = {
  ...us,
  name: 'CA'
}

export default lang
